import { RefObject } from "react";
import { QuizMode, QuizScene, QuizHandler } from "../../lib/quiz/Quiz";
import QuizModeButton from "./QuizModeButton";
import quizLogo from "../../img/quizzes/logo.png";
import topAkikun from "../../img/quizzes/top_akikun.png";
import "./QuizModeSelector.scoped.scss";

interface Props {
  quizHandler: QuizHandler;
  setQuizScene: React.Dispatch<React.SetStateAction<QuizScene>>;
  pageTopRef: RefObject<HTMLDivElement>;
}

export default function QuizModeSelector({
  quizHandler,
  setQuizScene,
  pageTopRef,
}: Props) {
  const modes: Array<QuizMode> = ["easy", "normal", "hard", "expert"];
  const scrollToTop = () => {
    pageTopRef.current!.scrollIntoView({
      behavior: "smooth",
    });
  };
  const selectQuizMode = (mode: QuizMode) => {
    return () => {
      quizHandler.startQuiz(mode);
      setQuizScene("playing");
      scrollToTop();
    };
  };
  const description = `
    アキくんに関する様々なことをクイズにしてみました。
    アキくんのことをもっと知りたい方、4段階のクイズから選んで挑戦してみてね！
  `;
  return (
    <div className="w-full max-w-full m-auto sm:max-w-4xl">
      <div className="flex items-center justify-center px-3">
        <div className="w-4/5 sm:w-3/4">
          <img src={quizLogo} alt="アキくんクイズ！" />
          <p className="hidden px-5 py-1 text-base text-gray-500 quiz-description sm:block sm:text-md md:text-xl">
            {description}
          </p>
        </div>
        <img
          className="w-1/5 sm:w-1/4"
          src={topAkikun}
          alt="アキくんクイズ！"
        />
      </div>
      <p className="block px-5 mt-1 text-base text-gray-500 quiz-description sm:hidden">
        {description}
      </p>
      <div className="m-5 grid sm:grid-cols-2 grid-cols-1 gap-2 sm:gap-4">
        {modes.map((mode) => {
          return (
            <div key={mode} onClick={selectQuizMode(mode)}>
              <QuizModeButton
                quizHandler={quizHandler}
                quizMode={mode}
              ></QuizModeButton>
            </div>
          );
        })}
      </div>
    </div>
  );
}
